import React from 'react';

// STYLES

import * as S from './styles/SignUpPersuasion.styles';

// ICONS
import SignUpLockSmall from '../../../../../stories/Icons/SignUpLockSmall';

// COMPONENTS

import {PrimaryLink} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

type StylePropsType = {
  [k: string]: any;
};

const SignUpPersuasionText: React.FC<{
  styledProps?: StylePropsType;
  dealPrice: number;
  showStartingFrom: boolean;
}> = ({styledProps, dealPrice, showStartingFrom}) => {
  const {
    perRoomPerNightLabelTextTransform,
    perRoomPerNightTextSize,
    dealPriceTextSize,
  } = styledProps;

  /**
   * signUpDealLogicLabelProps = {
   *    shouldBold: true / false,
   *
   * }
   *
   * signUpDealStyleProps = {
   *  borderRadius: ';
   * }
   */

  return (
    <>
      <S.SignUpHeaderWrap>
        {' '}
        <SignUpLockSmall />
        Member only price!
      </S.SignUpHeaderWrap>
      <S.SignUpContentWrap>
        <S.SignUpDealPrice>
          {showStartingFrom && (
            <S.SignUpDealPerNight
              perRoomPerNightLabelTextTransform={perRoomPerNightLabelTextTransform}
              perRoomPerNightTextSize={perRoomPerNightTextSize}
            >
              Starting from&nbsp;
            </S.SignUpDealPerNight>
          )}
          <S.SignUpDealPriceText dealPriceTextSize={dealPriceTextSize}>
            ₹{dealPrice}
          </S.SignUpDealPriceText>
          <S.SignUpDealPerNight
            perRoomPerNightLabelTextTransform={perRoomPerNightLabelTextTransform}
            perRoomPerNightTextSize={perRoomPerNightTextSize}
          >
            per room / per night
          </S.SignUpDealPerNight>
        </S.SignUpDealPrice>
        {/* <MemberPriceWrapDiv>
          <SignUpMemberPrice>Get exclusive member only price </SignUpMemberPrice>
          <SignUpDealPriceText>₹2750</SignUpDealPriceText>
        </MemberPriceWrapDiv> */}
        <PrimaryLink>Login Now</PrimaryLink>
      </S.SignUpContentWrap>
    </>
  );
};

function SignUpPersiasion({
  onClick,
  styledProps = {},
  dealPrice,
  showStartingFrom = false,
}: {
  onClick: (event?: React.MouseEvent<HTMLElement>) => void;
  styledProps?: StylePropsType;
  dealPrice: number;
  showStartingFrom?: boolean;
}) {
  const {width, ...signUpPersuasionTextCompProps} = styledProps;

  return (
    <S.Container onClick={onClick} width={width}>
      {/* <IconWrap>
        <OfferIcon {...offerIconProps} />
      </IconWrap> */}
      <SignUpPersuasionText
        styledProps={signUpPersuasionTextCompProps}
        dealPrice={dealPrice}
        showStartingFrom={showStartingFrom}
      />
    </S.Container>
  );
}

export default SignUpPersiasion;
